<script setup lang="ts">
import { useAuthStore } from '@/stores';

const auth = useAuthStore();

const classes = {
    menu: 'text-gray-800 hover:bg-gray-100 group flex items-center px-2 py-2.5 pl-5 text-sm font-medium rounded-md decoration-none',
    active: 'bg-blue-50! text-blue-600!',
};
</script>

<template>
    <div class="flex items-center px-4 py-4">
        <img src="/icon_96x96.png" alt="" class="h-8 w-auto" />
        <div class="ml-2">
            <div class="text-gray-800 font-bold text-xl">Admin</div>
        </div>
    </div>

    <nav class="flex-1 overflow-y-auto flex flex-col gap-1 p-4" style="scrollbar-width: none">
        <router-link :class="classes.menu" :active-class="classes.active" to="/dashboard">Dashboard</router-link>
        <router-link :class="classes.menu" :active-class="classes.active" to="/enquiries">Enquiries</router-link>
        <router-link :class="classes.menu" :active-class="classes.active" to="/customers">Customers</router-link>
        <router-link :class="classes.menu" :active-class="classes.active" to="/categories" v-if="auth.is('admin|dev')">Categories</router-link>
        <router-link :class="classes.menu" :active-class="classes.active" to="/partners">Partners</router-link>
        <router-link :class="classes.menu" :active-class="classes.active" to="/locations" v-if="auth.is('admin|dev')">Locations</router-link>
        <router-link :class="classes.menu" :active-class="classes.active" to="/staffs" v-if="auth.is('admin|dev')">Staffs</router-link>
        <router-link :class="classes.menu" :active-class="classes.active" to="/settings" v-if="auth.is('admin|dev')">Settings</router-link>
        <router-link :class="classes.menu" :active-class="classes.active" to="/reports" v-if="auth.is('admin|dev|staff')">Reports</router-link>
        <router-link :class="classes.menu" :active-class="classes.active" to="/payments" v-if="auth.is('dev')">Payments</router-link>
        <router-link :class="classes.menu" :active-class="classes.active" to="/cache" v-if="auth.is('dev')">Cache</router-link>
        <router-link :class="classes.menu" :active-class="classes.active" to="/queue" v-if="auth.is('dev')">Queue</router-link>
    </nav>
</template>
